import axios from "axios";
import * as Utils from './utils';

const nav = document.querySelector('nav'),
    scrollToLinks = document.querySelectorAll('a[data-section]'),
    sections = document.querySelectorAll('.js-section');

let pageInitialized = false,
    sectionData = [],
    sectionInView;

export function init() {
    sectionInView = sections[0].id;

    // Global Resize
    window.addEventListener('resize', Utils.debounce(globalResize, 250));
    // Trigger resize once on page load
    window.dispatchEvent(new Event('resize'));

    // Popstate, scroll to correct page position...
    window.addEventListener('popstate', e => {
        e.preventDefault();

        let dist = 0;

        if (e.state == null) {
            return;
        }

        // We need to turn off the window scroll function so that it doesn't push another state
        // on to the history stack when we animate the scroll position next
        window.removeEventListener('scroll');

        dist = $(e.state.id).offset().top;

        scrollBody(dist, function () {
            // Re-attach the scroll event after we've finished animating the scroll position
            window.addEventListener('scroll', Utils.debounce(calcSectionInView, 150));
        });
    });

    // # link clicks
    scrollToLinks.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            
            scrollBody(document.getElementById(el.dataset.section).getBoundingClientRect().top + window.scrollY);
        })
    });

    // Keypresses
    document.addEventListener('keydown', function (e) {
        // Up
        if (e.key === 'ArrowUp' || e.key === 'Up') {
            e.preventDefault();
            scrollUp();
        }

        // Down
        if (e.key === 'ArrowDown' || e.key === 'Down') {
            e.preventDefault();
            scrollDown();
        }
    });
}

function globalResize() {
    sectionData = [];

    // Get all sectionData recorded
    sections.forEach(el => {
        let rect = el.getBoundingClientRect();

        sectionData.push({
            top: rect.top + window.scrollY,
            height: rect.height,
            id: el.id
        });
    });

    // Only run pageInit the first time...
    if (! pageInitialized) {
        pageInit();

        pageInitialized = true;
    }
}

function calcSectionInView () {
    // Track which main section is most in view now after the scroll has happened...
    sectionData.forEach((item, i) => {
        if (window.scrollY + (nav.getBoundingClientRect().height / 2) >= item.top) {
            if (sectionInView !== item.id) {
                sectionInView = item.id;

                // Add pushState URL
                history.pushState({id: '#' + item.id}, item.id + ' | Boxhead', item.id);

                // // Set active class to nav item
                // nav.querySelectorAll('.is-active').forEach(el => {
                //     el.classList.remove('is-active');
                // });

                // nav.querySelectorAll('a[data-section*=' + item.id + ']').forEach(el => {
                //     el.classList.add('is-active');
                // });

                // // Set BH Logo SVG colour and nav text colour to section colour
                // if (document.getElementById(item.id).dataset.color) {
                //     nav.style.color = document.getElementById(item.id).dataset.color;
                // }
            }

            return false;
        }
    });
}

function scrollBody(distance, callback) {
    callback = typeof callback !== 'undefined' ? callback : false;

    window.scroll({
        top: distance,
        left: 0,
        behavior: 'smooth',
    });

    calcSectionInView();

    // Do we have a custom callback to run too?
    if (callback !== false) {
        callback();
    }
}

function pageInit() {
    window.addEventListener('scroll', Utils.debounce(calcSectionInView, 150));

    // Do we need to scroll to a section from the URL?
    if (window.location.pathname && window.location.pathname !== '/') {
        // Get just the last segment
        var path = window.location.pathname.split('/'),
            lastSegment = path[path.length - 1],
            targetTop = document.getElementById(lastSegment).getBoundingClientRect().top + window.scrollY;

        scrollBody(targetTop);
    }

    // On first pageload we need to see if scrolltop is still 0 after say 500ms
    // If it is, we know that no other funciton has scrolled us elsewhere in the page
    // so we should fadein the first section ''
    setTimeout(function () {
        if (window.scrollY === 0) {
            const firstSection = sections[0];

            if (firstSection.dataset.color) {
                const sectionColour = firstSection.dataset.color;

                document.querySelector('nav').style.color = sectionColour;
            }
        }
    }, 1500);
}

function scrollDown() {
    // Use current section to determine if previous section exits and scroll to it
    var nextSection = document.getElementById(sectionInView).nextElementSibling.id,
        targetTop = 0;

    // We could be on the first feature img trying to scroll up.
    // If prevSection ID is undefined, traverse to closest section, then the prev one.
    if (typeof nextSection === 'undefined') {
        nextSection = document.getElementById(sectionInView).closest('.js-section').nextElementSibling.id;
    }

    // If nextSection is still undefined we must be at the bottom of the page...
    if (typeof nextSection !== 'undefined') {
        targetTop = document.getElementById(nextSection).getBoundingClientRect().top + window.scrollY;

        scrollBody(targetTop);
    }
}

function scrollUp() {
    // Use current section to determine if previous section exits and scroll to it
    var prevSection = document.getElementById(sectionInView).previousElementSibling.id,
        targetTop = 0;

    // We could be on the first feature img trying to scroll up.
    // If prevSection ID is undefined, traverse to closest section, then the prev one.
    if (typeof prevSection === 'undefined') {
        prevSection = document.getElementById(sectionInView).closest('.js-section').previousElementSibling.attr('id');
    }

    // If prevSection is still undefined we must be at the top of the page...
    if (typeof prevSection !== 'undefined') {
        targetTop = document.getElementById(prevSection).getBoundingClientRect().top + window.scrollY

        scrollBody(targetTop);
    }
}